import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';
import InputMask from 'react-input-mask';

class ScheduleGradeOffScheduleLineTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal_vacation: false,
      loaded: 0,
      staff: this.props.staff,
      schedule: this.props.schedule,
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      unavailable_staff_ids: this.props.unavailable_staff_ids,
      date_start: this.props.staff.date_start_str,
      date_finish: this.props.staff.date_finish_str,
    };

    this.add = this.add.bind(this);
    this.openVacationModal = this.openVacationModal.bind(this);
    
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  

  // Adiciono uma aeronave na escala
  add(event) {
    var confirm_text = "Tem certeza que gostaria alocar este colaborador para férias?";
    if(this.state.unavailable_staff_ids.includes(this.state.staff_id)) {
      confirm_text = "O colaborador está escalado, prosseguir mesmo assim?";
    }
    var confirm = window.confirm(confirm_text);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        schedule_id: this.props.schedule_id,
        schedule_grade_id: this.props.schedule_grade_id,
        staff_id: this.state.staff.id,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        change_schedule: event,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      self.setState({
        modal_vacation: false,
      });
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/adicionar/ferias', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }    
  }    

  // Adiciono uma aeronave na escala
  openVacationModal(event) {
    event.preventDefault();
    this.setState({
      modal_vacation: true,
    });
  }

  render() {
    var self = this;
    return (
    <div>
      <form onSubmit={this.openVacationModal}>
        <RequestApi ref={'request_api'} />
        <div className="row">
          <div className="col-md-4">
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" disabled />
          </div>
          <div className="col-md-4">
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" disabled />
          </div>
          <div className="col-md-3">
            <button type="submit" className="btn btn-success btn-block"><i className="fa fa-fw fa-sign-in"></i></button>
          </div>
        </div>
      </form>
      <Modal show={self.state.modal_vacation} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4>Será feita a alteração na escala do mês seguinte, caso o colaborador esteja escalado?</h4>
          <p>Obs.: Essa ação abrirá uma nova revisão caso a grade ja esteja aprovada. Igualando o primeiro dia do mês seguinte, com o último dia do período do colaborador nesta escala.</p>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_vacation: false}); self.props.handleAlert('', '', 'open'); }}><i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
              <div className="col-md-6">
                <button onClick={() => {self.add(true);}} className="btn btn-block btn-success"><i className="fa fa-fw fa-save"></i> SIM</button>
              </div>
              <div className="col-md-6">
                <button onClick={() => {self.add(false);}} className="btn btn-block btn-danger"><i className="fa fa-fw fa-save"></i> NÂO</button>
              </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_vacation: false}); self.props.handleAlert('', '', 'open'); }}><i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
    );
  }
}

export default ScheduleGradeOffScheduleLineTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeOffScheduleLineTab.js